var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "transition", duration: { enter: 500, leave: 500 } } },
    [
      _vm.isShowing
        ? _c("div", { staticClass: "auto-modal-wrapper" }, [
            _c("div", {
              staticClass: "auto-modal-overlay",
              on: {
                click: function ($event) {
                  return _vm.didSelectClose()
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "auto-modal" }, [
              _c(
                "button",
                {
                  staticClass: "auto-modal__close",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.didSelectClose()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Close")]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "24px",
                        height: "24px",
                        viewBox: "0 0 24 24",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Page-1",
                            stroke: "none",
                            "stroke-width": "1",
                            fill: "none",
                            "fill-rule": "evenodd",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "icon-cross",
                                transform: "translate(0.225162, 0.225162)",
                                fill: "#FFFFFE",
                                "fill-rule": "nonzero",
                              },
                            },
                            [
                              _c("polygon", {
                                attrs: {
                                  id: "Stroke-972",
                                  points:
                                    "3.54967604 0.0006 23.158676 19.6096 19.609 23.159276 0 3.55027604",
                                },
                              }),
                              _vm._v(" "),
                              _c("polygon", {
                                attrs: {
                                  id: "Stroke-973",
                                  points:
                                    "19.609 0 23.158676 3.54967604 3.54967604 23.158676 0 19.609",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "auto-modal__image" },
                [
                  _vm.settings.image
                    ? _c("lazy-background-image", {
                        attrs: {
                          alt: _vm.settings.image.alt,
                          src: _vm.settings.image.sizes.large,
                        },
                      })
                    : _c("div", { staticClass: "image image--placeholder" }),
                  _vm._v(" "),
                  _vm.settings.detail_icon
                    ? _c(
                        "div",
                        { staticClass: "auto-modal__image__icon" },
                        [
                          _c("lazy-image", {
                            attrs: {
                              src: _vm.settings.detail_icon.sizes.large,
                              alt: _vm.settings.detail_icon.alt,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "form",
                {
                  ref: "form",
                  staticClass: "auto-modal__body",
                  attrs: { action: _vm.formAction, method: "get" },
                },
                [
                  _c("h1", {
                    staticClass: "auto-modal__body__title",
                    domProps: { innerHTML: _vm._s(_vm.settings.title) },
                  }),
                  _vm._v(" "),
                  _vm.settings.description.length
                    ? _c("p", {
                        staticClass: "auto-modal__body__description",
                        domProps: {
                          innerHTML: _vm._s(_vm.settings.description),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.settings.links.length > 1
                    ? _c("ul", { staticClass: "auto-modal__body__links" }, [
                        _c("li", [
                          _c(
                            "div",
                            {
                              staticClass: "auto-modal__body__links__dropdown",
                            },
                            [
                              _c(
                                "button",
                                { staticClass: "button button--big" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.dropdownLabel),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedPageIndex,
                                      expression: "selectedPageIndex",
                                    },
                                  ],
                                  staticClass:
                                    "auto-modal__body__links__dropdown__input",
                                  attrs: { name: "ref" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.selectedPageIndex = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", {
                                    attrs: { value: "" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.settings.link_label
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.settings.links,
                                    function (link, index) {
                                      return _c("option", {
                                        key: "option-" + index,
                                        domProps: {
                                          value: index,
                                          innerHTML: _vm._s(link.label),
                                        },
                                      })
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _vm.settings.links.length === 1
                    ? _c(
                        "ul",
                        { staticClass: "auto-modal__body__links" },
                        _vm._l(_vm.settings.links, function (link) {
                          return _c("li", { key: link.page }, [
                            _c(
                              "a",
                              {
                                staticClass: "button button--big",
                                attrs: { href: link.page },
                              },
                              [
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(link.label) },
                                }),
                              ]
                            ),
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/AutoModalContent.vue